<template>
  <main>
    <transition name="fade">
        <div v-if="fancybox" class="fancybox">
            <div class="loader">Loading...</div>
            <button class="close heavy" role="close-button" @click="closeVid()"></button>
            <vimeo-player class="player" ref="player" :video-id="videoID" @ended="closeVid()" />
        </div>
    </transition>
    <div class="paths" role="listbox">
      Derivas
      <ul>
        <li @click="togglePath('myPath')" class="myPath">Minha deriva<hr /></li>
        <li @click="togglePath('BE')">Bergman – Monumento às Bandeiras</li>
        <li @click="togglePath('CA')">Casé – Páteo do Colégio</li>
        <li @click="togglePath('DA')">Daniel – Ocupação São João</li>
        <li @click="togglePath('DI')">Diga – Vila Itororó</li>
        <li @click="togglePath('DR')">Drão – Igreja Nossa Senhora do Rosário dos Homens Pretos</li>
        <li @click="togglePath('JU')">Júlio – Centro Cultural do Jabaquara</li>
        <li @click="togglePath('SA')">Sabrina – Vale do Anhangabaú</li>
        <li @click="togglePath('BO')">Vinhetas – Fantasma do Borba Gato</li>
      </ul>
    </div>
    <div class="bgimg">
      <svg ref="lines" class="lines">
        <line
          v-for="(line, key) in positions"
          :key="key"
          :x1="line.x1"
          :y1="line.y1"
          :x2="line.x2"
          :y2="line.y2"
          />
      </svg>
      <div class="pins">
        <button ref="abertura" @click="openVid('159699169')" class="pin abertura path" style="left:48.63%; top:15.32%;">
          <div class="tooltip">
            <b>ABERTURA</b>
            <p>No princípio era o Verbo.</p>
          </div>
        </button>

        <button ref="fechamento" @click="openVid('159699558')" class="pin fechamento path" style="left: 47.35%; top: 51.25%;">
          <div class="tooltip">
            <b>FECHAMENTO</b>
            <p>Fim</p>
          </div>
        </button>

        <div class="Vinhetas" ref="BO">

          <button ref="BO01" @click="openVid('159647395')" class="pin" style="left:96.45%; top:59.83%;">
            <div class="tooltip">
              <b>Borba 01</b>
              <p>Praça da República</p>
            </div>
          </button>

          <button ref="BO02" @click="openVid('159647406')" class="pin" style="left:76.94%; top:26.52%;">
            <div class="tooltip">
              <b>Borba 02</b>
              <p>Ocupação São João</p>
            </div>
          </button>

          <button ref="BO03" @click="openVid('159647423')" class="pin" style="left:51.69%; top:68.91%;">
            <div class="tooltip">
              <b>Borba 03</b>
              <p>Largo do Payssandu</p>
            </div>
          </button>

          <button ref="BO04" @click="openVid('159647436')" class="pin" style="left:83.9%; top:17.38%;">
            <div class="tooltip">
              <b>Borba 04</b>
              <p>Ocupação de Moradia</p>
            </div>
          </button>

          <button ref="BO05" @click="openVid('159647459')" class="pin" style="left: 46%; top: 29.4%;">
            <div class="tooltip">
              <b>Borba 05</b>
              <p>Avenida São João</p>
            </div>
          </button>

          <button ref="BO06" @click="openVid('159647473')" class="pin" style="left: 79%; top: 70.92%;">
            <div class="tooltip">
              <b>Borba 06</b>
              <p>Indígenas no Anhangabaú</p>
            </div>
          </button>

          <button ref="BO07" @click="openVid('159647493')" class="pin" style="left: 53.8%; top: 46.5%;">
            <div class="tooltip">
              <b>Borba 07</b>
              <p>Limpeza</p>
            </div>
          </button>

          <button ref="BO08" @click="openVid('159647515')" class="pin" style="left:19.52%; top:39.28%;">
            <div class="tooltip">
              <b>Borba 08</b>
              <p>Viaduto do Chá</p>
            </div>
          </button>

          <button ref="BO09" @click="openVid('159647541')" class="pin" style="left:69%; top:77.10%;">
            <div class="tooltip">
              <b>Borba 09</b>
              <p>Bandeira</p>
            </div>
          </button>

          <button ref="BO10" @click="openVid('159647566')" class="pin" style="left: 44%; top: 46.3%;">
            <div class="tooltip">
              <b>Borba 10</b>
              <p>Prefeitura</p>
            </div>
          </button>

          <button ref="BO11" @click="openVid('159647579')" class="pin" style="left: 75.6%; top: 18.4%;">
            <div class="tooltip">
              <b>Borba 11</b>
              <p>Padre Anchieta</p>
            </div>
          </button>

          <button ref="BO12" @click="openVid('159647598')" class="pin" style="left:77.82%; top:37.83%;">
            <div class="tooltip">
              <b>Borba 12</b>
              <p>Igreja dos Enforcados</p>
            </div>
          </button>

          <button ref="BO13" @click="openVid('159647618')" class="pin" style="left:11.5%; top:25.96%;">
            <div class="tooltip">
              <b>Borba 13</b>
              <p>Demolição</p>
            </div>
          </button>

          <button ref="BO14" @click="openVid('159647666')" class="pin" style="left:17.58%; top:81.28%;">
            <div class="tooltip">
              <b>Borba 14</b>
              <p>Casa histórica</p>
            </div>
          </button>

          <button ref="BO15" @click="openVid('159647687')" class="pin" style="left: 38.1%; top: 17.3%;">
            <div class="tooltip">
              <b>Borba 15</b>
              <p>Centro Cultural do Jabaquara</p>
            </div>
          </button>

          <button ref="BO16" @click="openVid('159647694')" class="pin" style="left:64.52%; top:34.76%;">
            <div class="tooltip">
              <b>Borba 16</b>
              <p>Ciclista</p>
            </div>
          </button>

        </div>
        <div class="Bergman" ref="BE">
          <button ref="BE01" @click="openVid('155806193')" class="pin" style="left:79.27%; top:63.29%;">
            <div class="tooltip">
              <b>BERGMAN 01</b>
              <p>A busca de um embranquecimento.</p>
            </div>
          </button>

          <button ref="BE02" @click="openVid('155806727')" class="pin" style="left:33.39%; top:90.53%;">
            <div class="tooltip">
              <b>BERGMAN 02</b>
              <p>Exaltação do bandeirante.</p>
            </div>
          </button>

          <button ref="BE03" @click="openVid('155806801')" class="pin" style="left:68.55%; top:57.49%;">
            <div class="tooltip">
              <b>BERGMAN 03</b>
              <p>Homem branco fecundador civilizador.</p>
            </div>
          </button>

          <button ref="BE04" @click="openVid('155807039')" class="pin" style="left:27.66%; top:36.49%;">
            <div class="tooltip">
              <b>BERGMAN 04</b>
              <p>O negro é o criminoso.</p>
            </div>
          </button>

          <button ref="BE05" @click="openVid('155807244')" class="pin" style="left:96%; top:50.36%;">
            <div class="tooltip">
              <b>BERGMAN 05</b>
              <p>A herança do menino da fundação casa.</p>
            </div>
          </button>

          <button ref="BE06" @click="openVid('155808301')" class="pin" style="left:64.27%; top:3.84%;">
            <div class="tooltip">
              <b>BERGMAN 06</b>
              <p>Quais mulheres morrem mais, quais mulheres morrem menos...</p>
            </div>
          </button>

          <button ref="BE07" @click="openVid('155808305')" class="pin" style="left:52.42%; top:53.48%;">
            <div class="tooltip">
              <b>BERGMAN 07</b>
              <p>O governador está no palácio dos bandeirantes e os pretos estão lá na fundação casa.</p>
            </div>
          </button>

          <button ref="BE08" @click="openVid('155808307')" class="pin" style="left:62.18%; top:67.86%;">
            <div class="tooltip">
              <b>BERGMAN 08</b>
              <p>Quem fica perto dos pobres é a polícia.</p>
            </div>
          </button>

          <button ref="BE09" @click="openVid('155808308')" class="pin" style="left:27.26%; top:6.80%;">
            <div class="tooltip">
              <b>BERGMAN 09</b>
              <p>Ideologia burguesa.</p>
            </div>
          </button>

          <button ref="BE10" @click="openVid('155808314')" class="pin" style="left:89.84%; top:61.95%;">
            <div class="tooltip">
              <b>BERGMAN 10</b>
              <p>Mito fundador bandeirante.</p>
            </div>
          </button>
        </div>
        <div class="Case" ref="CA">
          <button ref="CA01" @click="openVid('155804023')" class="pin" style="left:72.74%; top:18.72%;">
            <div class="tooltip">
              <b>CASÉ 01</b>
              <p>Sou indígena e moro lá em Olivença.</p>
            </div>
          </button>

          <button ref="CA02" @click="openVid('155804024')" class="pin" style="left:4.52%; top:33.15%;">
            <div class="tooltip">
              <b>CASÉ 02</b>
              <p>É uma cidade murada, muito parecida com as cidades medievais</p>
            </div>
          </button>

          <button ref="CA03" @click="openVid('155804025')" class="pin" style="left:52.66%; top:90.36%;">
            <div class="tooltip">
              <b>CASÉ 03</b>
              <p>Vai dar enchente mesmo!!!</p>
            </div>
          </button>

          <button ref="CA04" @click="openVid('155804029')" class="pin" style="left:87.10%; top:52.48%;">
            <div class="tooltip">
              <b>CASÉ 04</b>
              <p>A minha visão é que esta cidade nunca foi uma cidade desinteressante.</p>
            </div>
          </button>

          <button ref="CA05" @click="openVid('155804031')" class="pin" style="left:70.48%; top:31.53%;">
            <div class="tooltip">
              <b>CASÉ 05</b>
              <p>A Várzea do Carmo é reduto, é território indígena, negro e popular.</p>
            </div>
          </button>

          <button ref="CA06" @click="openVid('155804032')" class="pin" style="left:87.58%; top:28.58%;">
            <div class="tooltip">
              <b>CASÉ 06</b>
              <p>O tamanduateí é uma espécie de muro de Berlim.</p>
            </div>
          </button>

          <button ref="CA07" @click="openVid('155804033')" class="pin" style="left:54.52%; top:63.96%;">
            <div class="tooltip">
              <b>CASÉ 07</b>
              <p>Aqui tinha a igreja Nossa Senhora do Rosário dos Homens Pretos.ç onde fica a Bolsa de Valores.</p>
            </div>
          </button>

          <button ref="CA08" @click="openVid('155804042')" class="pin" style="left:48.31%; top:47.91%;">
            <div class="tooltip">
              <b>CASÉ 08</b>
              <p>As estruturas de poder estão todas aqui.</p>
            </div>
          </button>

          <button ref="CA09" @click="openVid('155804043')" class="pin" style="left:15.97%; top:16.77%;">
            <div class="tooltip">
              <b>CASÉ 09</b>
              <p>&quot;Peidar pode... Agora, fumar num pode, né?&quot;</p>
            </div>
          </button>

          <button ref="CA10" @click="openVid('155804036')" class="pin" style="left:74.68%; top:15.10%;">
            <div class="tooltip">
              <b>CASÉ 10</b>
              <p>É isso que a gente chama de território.</p>
            </div>
          </button>

          <button ref="CA11" @click="openVid('155804037')" class="pin" style="left:23.55%; top:68.19%;">
            <div class="tooltip">
              <b>CASÉ 11</b>
              <p>O índio também é preto na visão do português.</p>
            </div>
          </button>

          <button ref="CA12" @click="openVid('155804035')" class="pin" style="left:83.87%; top:66.69%;">
            <div class="tooltip">
              <b>CASÉ 12</b>
              <p>Oh, devolva nossas terras que essas terras nos pertencem...</p>
            </div>
          </button>

          <button ref="CA13" @click="openVid('155804778')" class="pin" style="left:97.18%; top:89.69%;">
            <div class="tooltip">
              <b>CASÉ 13</b>
              <p>&quot;Jacy îandé Jacy Mba-e pé moindy îandé taba. Tup_our tym. Isapé îandé taba.&quot;</p>
            </div>
          </button>

          <button ref="CA14" @click="openVid('163932325')" class="pin" style="left:39.52%; top:74.48%;">
            <div class="tooltip">
              <b>CASÉ 14</b>
              <p>Esqueci de falar da cerca</p>
            </div>
          </button>

          <button ref="CA15" @click="openVid('163926260')" class="pin" style="left:33.47%; top:29.03%;">
            <div class="tooltip">
              <b>CASÉ 15</b>
              <p>Politécnica.</p>
            </div>
          </button>
        </div>
        <div class="Daniel" ref="DA">
          <button ref="DA01" @click="openVid('156085447')" class="pin" style="left:68.79%; top:83.90%;">
            <div class="tooltip">
              <b>DANIEL 01</b>
              <p>Qual é a lógica de uma família manter com dois, três filhos uma casa pagando aluguel?</p>
            </div>
          </button>

          <button ref="DA02" @click="openVid('156085448')" class="pin" style="left:70.16%; top:10.53%;">
            <div class="tooltip">
              <b>DANIEL 02</b>
              <p>Especulação imobiliária que a gente chama no movimento de corrupção imobiliária.</p>
            </div>
          </button>

          <button ref="DA03" @click="openVid('156085449')" class="pin" style="left:38.63%; top:33.82%;">
            <div class="tooltip">
              <b>DANIEL 03</b>
              <p>Vejo uma perspectiva dos movimentos levantarem essa bandeira, entende?</p>
            </div>
          </button>

          <button ref="DA04" @click="openVid('156085451')" class="pin" style="left:48.71%; top:42.06%;">
            <div class="tooltip">
              <b>DANIEL 04</b>
              <p>Aí o movimento entrou e praticamente tornou o espaço habitável.</p>
            </div>
          </button>

          <button ref="DA05" @click="openVid('156085452')" class="pin" style="left:7.50%; top:53.09%;">
            <div class="tooltip">
              <b>DANIEL 05</b>
              <p>Um prédio que podia estar atendendo mais ou menos 200 famílias está vazio às moscas.</p>
            </div>
          </button>

          <button ref="DA06" @click="openVid('156085455')" class="pin" style="left:69.60%; top:27.35%;">
            <div class="tooltip">
              <b>DANIEL 06</b>
              <p>O Centro é realmente a área que grita mesmo!</p>
            </div>
          </button>

          <button ref="DA07" @click="openVid('156085453')" class="pin" style="left:75.56%; top:46.24%;">
            <div class="tooltip">
              <b>DANIEL 07</b>
              <p>Os números são assustadores.</p>
            </div>
          </button>

          <button ref="DA08" @click="openVid('156085456')" class="pin" style="left:85%; top:2.79%;">
            <div class="tooltip">
              <b>DANIEL 08</b>
              <p>O Movimento são as famílias e a ocupação é uma ferramenta.</p>
            </div>
          </button>

          <button ref="DA09" @click="openVid('156085459')" class="pin" style="left:29.03%; top:24.90%;">
            <div class="tooltip">
              <b>DANIEL 09</b>
              <p>A cidade é conflito. Se você não quer conflito vá viver num feudo.</p>
            </div>
          </button>

          <button ref="DA10" @click="openVid('156085463')" class="pin" style="left:42.66%; top:92.59%;">
            <div class="tooltip">
              <b>DANIEL 10</b>
              <p>Com as ocupações a gente ocupa um espaço que não tem ninguém.</p>
            </div>
          </button>

          <button ref="DA11" @click="openVid('156085464')" class="pin" style="left:84.60%; top:31.14%;">
            <div class="tooltip">
              <b>DANIEL 11</b>
              <p>Uma moradia que as pessoas deram significado para ser um espaço delas.</p>
            </div>
          </button>
        </div>
        <div class="Diga" ref="DI">
          <button ref="DI01" @click="openVid('155801649')" class="pin" style="left:70.08%; top:37.33%;">
            <div class="tooltip">
              <b>DIGA 01</b>
              <p>A Vila Itororó é um ótimo exemplo de um processo de gentrificação que está em curso.</p>
            </div>
          </button>

          <button ref="DI02" @click="openVid('155801650')" class="pin" style="left:93%; top:29%;">
            <div class="tooltip">
              <b>Diga 02</b>
              <p>E essa vila desde a década de 20 até o começo desse século até 2013, foi local de moradia.</p>
            </div>
          </button>

          <button ref="DI03" @click="openVid('155801651')" class="pin" style="left:73.39%; top:29.19%;">
            <div class="tooltip">
              <b>DIGA 03</b>
              <p>Querem impor uma narrativa dominante para apagar o que não interessa ao lucro.</p>
            </div>
          </button>

          <button ref="DI04" @click="openVid('155801652')" class="pin" style="left:93.55%; top:3.45%;">
            <div class="tooltip">
              <b>DIGA 04</b>
              <p>Habitar é cultura.</p>
            </div>
          </button>

          <button ref="DI05" @click="openVid('155801653')" class="pin" style="left:40.65%; top:78.44%;">
            <div class="tooltip">
              <b>DIGA 05</b>
              <p>Vocês estão usando a cultura de maneira cínica!</p>
            </div>
          </button>

          <button ref="DI06" @click="openVid('155801656')" class="pin" style="left:53.23%; top:29.58%;">
            <div class="tooltip">
              <b>DIGA 06</b>
              <p>É incrível, foram anos e anos de resistência aqui.</p>
            </div>
          </button>

          <button ref="DI07" @click="openVid('155801658')" class="pin" style="left:16.94%; top:83.79%;">
            <div class="tooltip">
              <b>DIGA 07</b>
              <p>Ali no terreno que é do Silvio Santos existiam casas tombadas.</p>
            </div>
          </button>

          <button ref="DI08" @click="openVid('155801662')" class="pin" style="left:67.66%; top:59.78%;">
            <div class="tooltip">
              <b>DIGA 08</b>
              <p>Pronto, acabou o carnaval de rua!</p>
            </div>
          </button>

          <button ref="DI09" @click="openVid('155801674')" class="pin" style="left:14.92%; top:8.08%;">
            <div class="tooltip">
              <b>DIGA 09</b>
              <p>A riqueza da Vila eram as pessoas que viviam aqui.</p>
            </div>
          </button>

          <button ref="DI10" @click="openVid('155801676')" class="pin" style="left:80.16%; top:35.21%;">
            <div class="tooltip">
              <b>DIGA 10</b>
              <p>O centro sempre foi um problema para as populações.</p>
            </div>
          </button>

          <button ref="DI11" @click="openVid('155801725')" class="pin" style="left:95.65%; top:54.99%;">
            <div class="tooltip">
              <b>DIGA 11</b>
              <p>O interesse é o lucro.</p>
            </div>
          </button>

          <button ref="DI12" @click="openVid('155801683')" class="pin" style="left:92.82%; top:41.56%;">
            <div class="tooltip">
              <b>DIGA 12</b>
              <p>Os corpos estão aí pra serem agenciados sem se dar conta disso.</p>
            </div>
          </button>

          <button ref="DI13" @click="openVid('155801702')" class="pin" style="left:70.65%; top:51.97%;">
            <div class="tooltip">
              <b>DIGA 13</b>
              <p>Se é lei Rouanet, envolve interesse privado.</p>
            </div>
          </button>

          <button ref="DI14" @click="openVid('159642594')" class="pin" style="left:6.21%; top:51.70%;">
            <div class="tooltip">
              <b>DIGA 14</b>
              <p>Bixiga Brodaway!</p>
            </div>
          </button>

          <button ref="DI15" @click="openVid('159642681')" class="pin" style="left:78.71%; top:78.77%;">
            <div class="tooltip">
              <b>Diga 15</b>
              <p>Deixar pessoas pobres, sem poder de consumo, morando aqui, é desvalorizar o entorno.</p>
            </div>
          </button>
        </div>
        <div class="Drao" ref="DR">
          <button ref="DR01" @click="openVid('156247255')" class="pin" style="left:16.85%; top:34.60%;">
            <div class="tooltip">
              <b>DRAO 01</b>
              <p>Atingiu em cheio a população indígena e a população preta.</p>
            </div>
          </button>

          <button ref="DR02" @click="openVid('156247256')" class="pin" style="left:39.35%; top:60.56%;">
            <div class="tooltip">
              <b>DRAO 02</b>
              <p>O Banco do Estado de São Paulo era a Igreja da Nossa Senhora do Rosário dos Homens Pretos.</p>
            </div>
          </button>

          <button ref="DR03" @click="openVid('156247258')" class="pin" style="left:84.92%; top:12.53%;">
            <div class="tooltip">
              <b>DRAO 03</b>
              <p>O que o Código de Posturas vai fazer?</p>
            </div>
          </button>

          <button ref="DR04" @click="openVid('156247257')" class="pin" style="left: 72.85%; top: 49.8%;">
            <div class="tooltip">
              <b>Drão 04</b>
              <p>Uma política oficial de governo de branqueamento da população.</p>
            </div>
          </button>

          <button ref="DR05" @click="openVid('156247260')" class="pin" style="left:63.55%; top:62.06%;">
            <div class="tooltip">
              <b>DRAO 05</b>
              <p>Um quilombo no meio da cidade de São Paulo?</p>
            </div>
          </button>

          <button ref="DR06" @click="openVid('156247261')" class="pin" style="left:13.15%; top:77.05%;">
            <div class="tooltip">
              <b>DRAO 06</b>
              <p>Há mais de 500 anos, o mesmo processo.</p>
            </div>
          </button>

          <button ref="DR07" @click="openVid('156247262')" class="pin" style="left:20.08%; top:98.50%;">
            <div class="tooltip">
              <b>DRAO 07</b>
              <p>A estátua da mãe preta em homenagem à memória das mulheres negras.</p>
            </div>
          </button>

          <button ref="DR08" @click="openVid('156247265')" class="pin" style="left:43.47%; top:66.80%;">
            <div class="tooltip">
              <b>DRAO 08</b>
              <p>A devoção dos santos pretos.</p>
            </div>
          </button>

          <button ref="DR09" @click="openVid('156247263')" class="pin" style="left:17.58%; top:65.40%;">
            <div class="tooltip">
              <b>DRAO 09</b>
              <p>Ama de leite.</p>
            </div>
          </button>

          <button ref="DR10" @click="openVid('156247264')" class="pin" style="left: 55.2%; top: 9%;">
            <div class="tooltip">
              <b>Drão 10</b>
              <p>Ainda é o mesmo tipo de padrão de segregação.</p>
            </div>
          </button>

          <button ref="DR11" @click="openVid('156247266')" class="pin" style="left:86.45%; top:94.93%;">
            <div class="tooltip">
              <b>DRAO 11</b>
              <p>Derruba, constrói, reconstrói, remodela, reorganiza, salubriza o ambiente, expulsa, segrega, mata!</p>
            </div>
          </button>

          <button ref="DR12" @click="openVid('156247267')" class="pin" style="left:38.47%; top:93.09%;">
            <div class="tooltip">
              <b>Drão 12</b>
              <p>“Imigrantes unidos jamais serão vencidos”</p>
            </div>
          </button>

          <button ref="DR13" @click="openVid('158700024')" class="pin" style="left:16.21%; top:48.19%;">
            <div class="tooltip">
              <b>Drão 13</b>
              <p>Operação Camanducaia</p>
            </div>
          </button>
        </div>
        <div class="Julio" ref="JU">
          <button ref="JU01" @click="openVid('155802343')" class="pin" style="left:21.69%; top:85.57%;">
            <div class="tooltip">
              <b>JULIO 01</b>
              <p>A árvore que sangrou.</p>
            </div>
          </button>

          <button ref="JU02" @click="openVid('155802344')" class="pin" style="left:11.85%; top:73.09%;">
            <div class="tooltip">
              <b>JULIO 02</b>
              <p>A escravidão persiste em outros elos, em outras correntes, mas ela existe.</p>
            </div>
          </button>

          <button ref="JU03" @click="openVid('155802345')" class="pin" style="left:37.26%; top:13.04%;">
            <div class="tooltip">
              <b>Júlio 03</b>
              <p>O primeiro Centro Cultural da cidade de São Paulo.</p>
            </div>
          </button>

          <button ref="JU04" @click="openVid('155802348')" class="pin" style="left:38.31%; top:49.19%;">
            <div class="tooltip">
              <b>JULIO 04</b>
              <p>Nós somos frutos de um mesmo sistema.</p>
            </div>
          </button>

          <button ref="JU05" @click="openVid('155802350')" class="pin" style="left:22.90%; top:44.01%;">
            <div class="tooltip">
              <b>JULIO 05</b>
              <p>Boto maracatu aqui até duas horas da manhã!</p>
            </div>
          </button>

          <button ref="JU06" @click="openVid('155802352')" class="pin" style="left:96.85%; top:47.13%;">
            <div class="tooltip">
              <b>JULIO 06</b>
              <p>“Poxa, sou vizinho da História.“ Mas que História?</p>
            </div>
          </button>

          <button ref="JU07" @click="openVid('155802356')" class="pin" style="left:87.26%; top:22.06%;">
            <div class="tooltip">
              <b>JULIO 07</b>
              <p>Aqui eram todos rios, riachos e mananciais.</p>
            </div>
          </button>

          <button ref="JU08" @click="openVid('155802386')" class="pin" style="left:21.94%; top:94.87%;">
            <div class="tooltip">
              <b>JULIO 08</b>
              <p>O primeiro advogado negro na história do Brasil.</p>
            </div>
          </button>

          <button ref="JU09" @click="openVid('155802424')" class="pin" style="left:78.71%; top:78.77%;">
            <div class="tooltip">
              <b>JULIO 09</b>
              <p>Fragmentos de ossos.</p>
            </div>
          </button>

          <button ref="JU10" @click="openVid('155802382')" class="pin" style="left:60.00%; top:42.51%;">
            <div class="tooltip">
              <b>JULIO 10</b>
              <p>Aqui foram colocados sacos de cimento, cal, terra.</p>
            </div>
          </button>

          <button ref="JU11" @click="openVid('155802393')" class="pin" style="left:79.76%; top:93.93%;">
            <div class="tooltip">
              <b>Júlio 11</b>
              <p>Ja-ba-quara: “Eu vim lá do alto”</p>
            </div>
          </button>

          <button ref="JU12" @click="openVid('155802402')" class="pin" style="left:71.05%; top:4.79%;">
            <div class="tooltip">
              <b>JULIO 12</b>
              <p>Esse aqui é o senhor, dono de escravos.</p>
            </div>
          </button>

          <button ref="JU13" @click="openVid('155802397')" class="pin" style="left:56.21%; top:77.10%;">
            <div class="tooltip">
              <b>JULIO 13</b>
              <p>A casa jesuítica.</p>
            </div>
          </button>
        </div>
        <div class="Sabrina" ref="SA">
          <button ref="SA01" @click="openVid('155803145')" class="pin" style="left:90.00%; top:86.07%;">
            <div class="tooltip">
              <b>SABRINA 01</b>
              <p>&quot;Mas qual que é a diferença entre Kassab e Haddad?&quot;</p>
            </div>
          </button>

          <button ref="SA02" @click="openVid('155803147')" class="pin" style="left:17.10%; top:9.19%;">
            <div class="tooltip">
              <b>SABRINA 02</b>
              <p>Ele pixa o pato Donald...</p>
            </div>
          </button>

          <button ref="SA03" @click="openVid('155803150')" class="pin" style="left:55.24%; top:99.22%;">
            <div class="tooltip">
              <b>SABRINA 03</b>
              <p>Uma cidade lucrativa. Cidadãos clientes.</p>
            </div>
          </button>

          <button ref="SA04" @click="openVid('155803155')" class="pin" style="left:38.47%; top:70.03%;">
            <div class="tooltip">
              <b>SABRINA 04</b>
              <p>Banco Itaú.</p>
            </div>
          </button>

          <button ref="SA05" @click="openVid('155803156')" class="pin" style="left:60.32%; top:14.43%;">
            <div class="tooltip">
              <b>SABRINA 05</b>
              <p>Entregar até a última gota de sangue das suas vidas pra conseguir sobreviver.</p>
            </div>
          </button>

          <button ref="SA06" @click="openVid('155803173')" class="pin" style="left:82.74%; top:32.98%;">
            <div class="tooltip">
              <b>SABRINA 06</b>
              <p>Lógica Perversa.</p>
            </div>
          </button>

          <button ref="SA07" @click="openVid('155803181')" class="pin" style="left:31.85%; top:81.45%;">
            <div class="tooltip">
              <b>SABRINA 07</b>
              <p>Hipergentrificação.</p>
            </div>
          </button>

          <button ref="SA08" @click="openVid('155803200')" class="pin" style="left:32.74%; top:94.43%;">
            <div class="tooltip">
              <b>SABRINA 08</b>
              <p>É exatamente um abandono especulativo.</p>
            </div>
          </button>

          <button ref="SA09" @click="openVid('155803211')" class="pin" style="left:76.77%; top:8.86%;">
            <div class="tooltip">
              <b>SABRINA 09</b>
              <p>O discurso da &quot;ressignificação&quot; limpa o território sem dizer que est&nbsp; limpando.</p>
            </div>
          </button>

          <button ref="SA10" @click="openVid('155803212')" class="pin" style="left:81.77%; top:60.72%;">
            <div class="tooltip">
              <b>SABRINA 10</b>
              <p>Pautas anticapitalistas.</p>
            </div>
          </button>

          <button ref="SA11" @click="openVid('159691858')" class="pin" style="left:97%; top:12.76%;">
            <div class="tooltip">
              <b>SABRINA 11</b>
              <p>Já expulsava antes, mas com a copa se começou a expulsar muito mais.</p>
            </div>
          </button>

          <button ref="SA12" @click="openVid('159691860')" class="pin" style="left:95%; top:21.78%;">
            <div class="tooltip">
              <b>SABRINA 12</b>
              <p>O capitalismo consegue capitalizar até...sua vontade de cagar.</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Videos',
  data() {
    return {
      fancybox: false,
      videoID: 0,
      path: [],
      positions: []
    }
  },
  methods: {
    openVid(id) {
      this.fancybox = true
      this.videoID = id
      this.$refs.player.update(id)
    },
    closeVid() {
      this.fancybox = false
      this.$refs.player.pause()
    },
    togglePath(ref) {
      this.path.forEach(element => {
        this.$refs[element].classList.remove('path')
      });
      if (ref === 'myPath') {
        this.path = []
        this.path = this.$route.params.path.match(/.{1,4}/g)
        if(this.path[this.path.length - 1] === 'CA25') {
          this.path.splice(-2, 2)
        }
      } else {
        this.path = []
        for ( let index = 1; index <= this.$refs[ref].childElementCount; index ++ ) {
          this.path.push(ref + ("0" + index).slice(-2))
        }
      }

      this.path.forEach(element => {
        this.$refs[element].classList.add('path')
      })

      this.getPositions()
    },
    getPositions() {
      let pos = []
      pos.push({
        x1: (this.$refs.abertura.getBoundingClientRect().left + this.$refs.abertura.getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().width * 100 + '%',
        y1: (this.$refs.abertura.getBoundingClientRect().top + this.$refs.abertura.getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().height * 100 + '%',
        x2: (this.$refs[this.path[0]].getBoundingClientRect().left + this.$refs[this.path[0]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().width * 100 + '%',
        y2: (this.$refs[this.path[0]].getBoundingClientRect().top + this.$refs[this.path[0]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().height * 100 + '%',
      })
      for (let index = 0; index < this.path.length; index++) {
        pos.push({
          x1: (this.$refs[this.path[index]].getBoundingClientRect().left + this.$refs[this.path[index]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().width * 100 + '%',
          y1: (this.$refs[this.path[index]].getBoundingClientRect().top + this.$refs[this.path[index]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().height * 100 + '%',
          x2: index === this.path.length - 1 ?
            (this.$refs.fechamento.getBoundingClientRect().left + this.$refs.fechamento.getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().width * 100 + '%' :
            (this.$refs[this.path[index + 1]].getBoundingClientRect().left + this.$refs[this.path[index + 1]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().width * 100 + '%',
          y2: index === this.path.length - 1 ?
            (this.$refs.fechamento.getBoundingClientRect().top + this.$refs.fechamento.getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().height * 100 + '%' :
            (this.$refs[this.path[index + 1]].getBoundingClientRect().top + this.$refs[this.path[index + 1]].getBoundingClientRect().width / 2) / this.$refs.lines.getBoundingClientRect().height * 100 + '%'
        })
      }
      this.positions = pos
    },
  },
  mounted() {
    this.togglePath('myPath')
  }
};
</script>

<style scoped>
p {
  margin: 0;
  margin-top: 5px;
}

hr {border: 1px solid #fff; margin-bottom: 0;}

.paths {
  position: fixed;
  z-index: 50;
  top: 0; right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3em;
  font-family: 'Bebas Neue', cursive;
  width: 7.5vw;
  min-width: 75px;
  height: 4vw;
  min-height: 40px;
  color: #fff;
  background-color: rgba(0, 0, 0, 1);
  cursor: pointer;
}

.paths:hover, .paths:focus {
  background-color: rgba(0, 0, 0, 0.75);
  text-decoration: underline;
}

.paths ul {
	visibility: hidden;
  opacity: 0;
	position: absolute;
  transition: all 0.5s ease;
  margin-top: 0;
  top: 100%;
	right: 0;
  display: none;
  background-color: #000;
  list-style-type: none;
  max-height: max(100vh - 40px, 100vh - 40vw);
  overflow-y: scroll;
}

.paths:hover ul, .paths:focus ul {
  visibility: visible;
  opacity: 1;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  padding: 10px 20px;
  text-align: right;
}

.paths ul li {  padding: 10px 0; }
.paths ul li:hover { text-decoration: underline; }

.bgimg {
  position: relative;
  height: 146.5vw;
  background-size: cover;
  padding-right: 5vw;
  padding-bottom: 7vw;
}

.lines {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
}
.lines line {stroke:rgb(0,0,0); stroke-width:0.4vw}

.pins {
  position: relative;
  width: 100%;
  height: 100%;
}

.pin {
  position: absolute;
  display: block;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  background-position: center;
  background-repeat: no-repeat;
  width: 1.5vw;
  height: 1.5vw;
  margin: 0.25vw;
  padding: 0;
}

.selected .pin, .path {
  border: 0.4vw solid #000;
}

.Vinhetas .pin, .abertura, .fechamento {
  background-image: url("~@/assets/pin_gold.png");
  width: 2vw;
  height: 2vw;
  margin: 0;
}
.Bergman .pin {
  background-image: url("~@/assets/pin_yellow.png");
}
.Case .pin {
  background-image: url("~@/assets/pin_red.png");
}
.Daniel .pin {
  background-image: url("~@/assets/pin_blue.png");
}
.Diga .pin {
  background-image: url("~@/assets/pin_white.png");
}
.Drao .pin {
  background-image: url("~@/assets/pin_black.png");
}
.Julio .pin {
  background-image: url("~@/assets/pin_green.png");
}
.Sabrina .pin {
  background-image: url("~@/assets/pin_purple.png");
}

.tooltip {
  content: attr(data-title) " - " attr(data-desc);
  background-color: #000;
  color: #fff;
  font-size: 13px;
  padding: 10px;
  position: absolute;
  left: 50%;
  top: 100%;
  width: 11vw;
  opacity: 0;
  transition: all 0.4s ease;
  border-radius: 10px;
  transform: translateX(-50%);
  z-index: 6;
  pointer-events: none;
}
.tooltip:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  left: 50%;
  bottom: 100%;
  border-style: solid;
  border-width: 0 0.5vw 0.5vw 0.5vw;
  border-color: transparent transparent #000 transparent;
  transition: all 0.4s ease;
  z-index: 5;
  transform: translateX(-50%);
}
.pin:hover .tooltip,
.pin:focus .tooltip {
  opacity: 1;
}

.fancybox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.85);
    z-index: 10;
}

.close {
  position: absolute;
  top: 2vw; right: 2vw;
  display: inline-block;
  width: 50px;
  height: 50px;
  overflow: hidden;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 30;
}
.close::before, .close::after {
  content: '';
  position: absolute;
  height: 8px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #fff;
  transition: all .3s ease-in-out;
}
.close::before {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.close::after {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.close:hover::before, .close:hover::after {
  background: rgb(165, 0, 0);
}

.player {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 10vh 10vw;
    object-fit: contain;
    z-index: 20;
}

.player >>> iframe {
    width:100%; height: 100%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>